import React, { useEffect } from "react";
import "./treatmentScreeningIntro.css";

export default function TreatmentScreeningIntro({ question, value, onChange }) {
  useEffect(() => {
    if (!value?.acknowledged) onChange({ acknowledged: true });
  }, [onChange, value?.acknowledged]);

  const intro = question.screening_intro || {};
  return (
    <section className="screening-intro">
      <div className="screening-intro__eyebrow">{intro.label || "Clinical Screening"}</div>
      <h2>{intro.treatment_name || question.question_text}</h2>
      <p>A few quick clinical questions so our doctors can confirm this treatment is safe for you.</p>
      <div className="screening-intro__callout">
        <strong>What we ask about:</strong> medical history relevant to this treatment, contraindications,
        medications you’re on, and any safety flags.
      </div>
    </section>
  );
}
